import { FormattedMessage, useIntl } from 'react-intl'
import { Item } from 'typings'
import { SummaryRow, Tag, TagsListTruncate } from 'ui'
import { messages } from '../messages'
import styles from './styles'

type Props = {
  audiences: Item[] | undefined
}

const CONTENT_MAX_WIDTH = 336

export function AudiencesRow(props: Props) {
  const { audiences } = props

  const { $t } = useIntl()

  if (!audiences) return null

  return (
    <SummaryRow>
      <SummaryRow.Title>
        <FormattedMessage {...messages.audiences.title} />
      </SummaryRow.Title>
      <SummaryRow.Value>
        <TagsListTruncate
          maxWidth={CONTENT_MAX_WIDTH}
          content={audiences.map(({ name }) => name)}
        >
          {audiences.map((item, index) => (
            <TagsListTruncate.Atom key={index}>
              <Tag className={styles.tag}>{item.name}</Tag>
            </TagsListTruncate.Atom>
          ))}
        </TagsListTruncate>
      </SummaryRow.Value>
    </SummaryRow>
  )
}
